var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLink({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.22181 19.7782C2.26919 17.8256 2.26919 14.6598 4.22181 12.7071L7.05024 9.87871C7.44076 9.48819 8.07393 9.48819 8.46445 9.87871C8.85498 10.2692 8.85498 10.9024 8.46445 11.2929L5.63603 14.1214C4.46445 15.2929 4.46445 17.1924 5.63603 18.364C6.8076 19.5356 8.70709 19.5356 9.87867 18.364L12.7071 15.5356C13.0976 15.145 13.7308 15.145 14.1213 15.5356C14.5118 15.9261 14.5118 16.5593 14.1213 16.9498L11.2929 19.7782C9.34026 21.7308 6.17443 21.7308 4.22181 19.7782ZM19.7782 4.22186C17.8255 2.26924 14.6597 2.26924 12.7071 4.22186L9.87867 7.05029C9.48814 7.44081 9.48814 8.07398 9.87867 8.4645C10.2692 8.85503 10.9024 8.85503 11.2929 8.4645L14.1213 5.63607C15.2929 4.4645 17.1924 4.4645 18.3639 5.63607C19.5355 6.80765 19.5355 8.70714 18.3639 9.87871L15.5355 12.7071C15.145 13.0977 15.145 13.7308 15.5355 14.1214C15.926 14.5119 16.5592 14.5119 16.9497 14.1214L19.7782 11.2929C21.7308 9.34031 21.7308 6.17448 19.7782 4.22186ZM8.46445 14.1214C8.07393 14.5119 8.07393 15.145 8.46445 15.5356C8.85498 15.9261 9.48814 15.9261 9.87867 15.5356L15.5355 9.87871C15.926 9.48819 15.926 8.85503 15.5355 8.4645C15.145 8.07398 14.5118 8.07398 14.1213 8.4645L8.46445 14.1214Z",
    fill: "currentColor"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLink);
export default ForwardRef;